import { useState } from "react";
import styles from "./AddCommunicationModal.module.css";
import Button from "../components/Button";

function AddCommunicationModal({ eventData, getComms }) {
  const [isOpen, setIsOpen] = useState(false);
  const userData = JSON.parse(localStorage.getItem("userLogin"));

  const openModal = () => {
    setIsOpen((x) => !x);
  };
  const closeModal = () => {
    document.getElementById("eventNotesText").value = "";
    setIsOpen((x) => !x);
  };

  const saveNote = async () => {
    const id = userData.userId;
    const username = userData.user;
    await fetch("/api/event/comm", {
      method: "post",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: new URLSearchParams({
        id: Number(id),
        user: username,
        banID: Number(eventData.idBanquetHeader),
        eventType: "COMM",
        eventDesc: document.getElementById("eventNotesText").value,
      }),
    })
      .then((res) => {
        res.json();
      })
      .then((data) => {
        getComms();
        closeModal();
      });
  };

  return (
    <>
      <Button type="pOutline" onClick={openModal}>
        Add Communication
      </Button>
      {isOpen && (
        <div className={styles.modalBackdrop}>
          <div className={`${styles.modalContent}`}>
            <h3 className={styles.modalHeader}>Add Communication</h3>
            <div className={styles.modalBody}>
              <textarea
                name=""
                id="eventNotesText"
                className={styles.commText}
                onKeyDown={(e) => {
                  if (e.key === "Enter" && !e.shiftKey) {
                    saveNote();
                  }
                }}
              ></textarea>
            </div>
            <div className={styles.buttonGroup}>
              <Button type="secondary" onClick={saveNote}>
                Save Note
              </Button>
              <Button type="" onClick={closeModal}>
                Cancel
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default AddCommunicationModal;
